/**
 * Created by shubham on 27/2/18.
 */

import { Injectable,Component }     from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { SessionHandler } from './session-handler.service';
import { ErrorHandler } from './error-handler.service';
import { APPCONFIG } from '../../config';
import { Observable } from 'rxjs/Rx';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { LoaderService } from '../../loader/loader.service';
import { DialogComponent } from '../../dialog/dialog.component';
import { Router } from '@angular/router';
import {TranslateService} from 'ng2-translate';
import { CommonService } from '../../shared/services/common.service';


@Injectable()
export class HttpService {

    public url:any = APPCONFIG.URL+"/_ah/api";

    public dialogRef;
    public headers = new Headers({'Content-Type': 'application/json','apiKey':''});
        constructor(private http: Http,private router: Router,private LoaderService: LoaderService, private dialog: MdDialog,public sessionHandler : SessionHandler,
                public errorHandler: ErrorHandler, private translate: TranslateService, public commonService:CommonService) {}

    getRequestWithoutAuth(url, showLoader) : Observable<Response[]> {
        if(showLoader) {this.showLoader();}
        let headers;
        headers = new Headers({ 'Content-Type': 'application/json', 'apiKey': APPCONFIG.apiKey});
        
        return this.http.get(this.url +"/"+url,{headers: headers})
            .map((res:Response) => this.errorCheckFunction(res.json(),url))
            .catch((error:any) => Observable.throw(this.handleError(error.json(),url)));
    }
    getRequestWithoutLoader(url) : Observable<Response[]> {
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
        let loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        let headers;
        let accessToken;
        if(loginDataArray){accessToken  = loginDataArray['accessToken'];}
        headers      = new Headers({ 'Content-Type': 'application/json', 'apiKey':APPCONFIG.apiKey, 'access-token': accessToken});
        
        return this.http.get(this.url +"/"+url,{headers: headers})
            .map((res:Response) => this.errorCheckFunction(res.json(),url))
            .catch((error:any) => Observable.throw(this.handleError(error.json(),url)));
    }
    getRequest(url) : Observable<Response[]> {
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
        this.showLoader();
        let loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        let headers;
        let accessToken;
        if(loginDataArray){accessToken  = loginDataArray['accessToken'];}
        headers = new Headers({ 'Content-Type': 'application/json', 'apiKey':APPCONFIG.apiKey, 'access-token': accessToken});
        
        return this.http.get(this.url +"/"+url,{headers: headers})
            .map((res:Response) => this.errorCheckFunction(res.json(),url))
            .catch((error:any) => Observable.throw(this.handleError(error.json(),url)));
    }
    getRequestForAutocomplete(url) : Observable<Response[]> {
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
        let loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        let accessToken;
        let headers;
        if(loginDataArray){accessToken  = loginDataArray['accessToken'];}
        headers = new Headers({ 'Content-Type': 'application/json', 'apiKey':APPCONFIG.apiKey, 'access-token': accessToken});

        return this.http.get(this.url +"/"+url,{headers: headers})
            .map((res:Response) => this.errorCheckFunction(res.json(),url))
            .catch((error:any) => Observable.throw(this.handleError(error.json(),url)));
    }

    postRequest(body: Object,api:string): Observable<Response[]> {
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime()/1000.0));
        this.showLoader();

        let loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        let accessToken;
        let headers;

        if(loginDataArray){
            accessToken  = loginDataArray['accessToken'];
        }

        let bodyString = JSON.stringify(body);
        if(api == 'userOperationsApi/v1/digiAccessLogin' || api == 'userOperationsApi/v1/googleLogin' || api == 'userRegistrationsApi/v1/register/serviceOwner'){
            headers      = new Headers({ 'Content-Type': 'application/json', 'apiKey':APPCONFIG.apiKey});
        } else{
            headers      = new Headers({ 'Content-Type': 'application/json', 'apiKey':APPCONFIG.apiKey, 'access-token': accessToken});
        }
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.url+"/"+api, body, options)
            .map((res:Response) => this.errorCheckFunction(res.json(),api))
            .catch((error:any) => Observable.throw(this.handleError(error.json(),api)))
    }

    public noUserError(){
        localStorage.clear();
        //this.commonService.setLoginRedirectUrl(window.location.hash);
        this.router.navigateByUrl('/login');
        this.onEnd();
    }

    public onEnd(): void {
        this.hideLoader();
    }

    public showLoader(): void {
        this.LoaderService.show();
    }
    public hideLoader(): void {
        this.LoaderService.hide();
    }

    public handleError(e: any,api) {
        let errorJson = e;

        if(errorJson.error && (api == 'userOperationsApi/v1/googleLogin' || api == 'userOperationsApi/v1/digiAccessLogin')){
            let msg = errorJson.error.message;
            this.translate.get(msg).subscribe((res: string) => {
                alert(res);
            });
            /*this.dialogRef = this.dialog.open(DialogComponent);
             this.dialogRef.componentInstance.msg = errorJson.error.message;*/
        } else if(errorJson.error && (api != 'userOperationsApi/v1/googleLogin' && api != 'userOperationsApi/v1/digiAccessLogin')){
            if(errorJson.error.code != 400 && errorJson.error.code != 412 && errorJson.error.code != 503){
                this.errorHandler.handle(errorJson);
            } else if(errorJson.error.code == 412 || errorJson.error.code == 503){
                this.dialogRef = this.dialog.open(DialogComponent,{disableClose:true});
                this.dialogRef.componentInstance.msg = "Something_went_wrong";
            } else{
                this.dialogRef = this.dialog.open(DialogComponent,{disableClose:true});
                this.dialogRef.componentInstance.msg = errorJson.error.message;
                if(errorJson.error.message == 'INVITATION_USED') {
                    this.dialogRef.afterClosed().subscribe(result => {
                        this.router.navigateByUrl('/login');
                    });
                }
            }
        }

        this.hideLoader();
        return false;
    }

    public errorCheckFunction(jsonResult, api) {
        return jsonResult;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/services/http.service.ts